import * as React from 'react';
import PropTypes from 'prop-types';
import { CookiePolicyButton, CookiePolicyLink, CookiePolicyText, CookiePolicyWrapper } from './styled';
import withCountryCode from '../../components/RoutesHoc/RoutesHoc';
import { privacy } from '../../helpers/routes';

const EuCookieBanner: React.ComponentType<{
  buildUrlWithCountry: (route: string) => string;
  handleClick: () => {};
  isDesktop: boolean;
}> = ({ isDesktop, handleClick, buildUrlWithCountry }) => (
  <CookiePolicyWrapper data-cy="cookie-policy-banner" isDesktop={isDesktop}>
    <CookiePolicyText isDesktop={isDesktop}>
      We use cookies to improve your shopping experience. By continuing to use our site, you are agreeing to receive all
      cookies. {isDesktop && <br />} Please read our{' '}
      <CookiePolicyLink href={buildUrlWithCountry(privacy)}>Privacy Policy</CookiePolicyLink> for more information.
    </CookiePolicyText>
    <CookiePolicyButton isDesktop={isDesktop} onClick={handleClick}>
      accept
    </CookiePolicyButton>
  </CookiePolicyWrapper>
);

EuCookieBanner.propTypes = {
  handleClick: PropTypes.func.isRequired,
  isDesktop: PropTypes.bool,
};

export default withCountryCode(EuCookieBanner);
